import { render, staticRenderFns } from "./CalculationOfferPage.vue?vue&type=template&id=bfdd1e86&scoped=true&"
import script from "./CalculationOfferPage.vue?vue&type=script&lang=js&"
export * from "./CalculationOfferPage.vue?vue&type=script&lang=js&"
import style0 from "./CalculationOfferPage.vue?vue&type=style&index=0&id=bfdd1e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd1e86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardActions,VCol,VRow,VSimpleTable})
